// @ts-nocheck
import { suggestionStyles } from "@insite/content-library/Widgets/ProductList/ProductListSuggestion";
import { css } from "styled-components";

Object.assign(suggestionStyles, {
    wrapper: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
});
